import {AuthorizedApiBase, IConfig, CancelToken } from "./authorization"
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.5.0.0 (NJsonSchema v11.4.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

export interface IConfigPublicClient {

    /**
     * @return OK
     */
    getConfigurationFront( cancelToken?: CancelToken): Promise<IConfigurationFront>;

    /**
     * @return OK
     */
    getConfigurationMobile( cancelToken?: CancelToken): Promise<IConfigurationMobile>;

    /**
     * @return OK
     */
    getConfigurationBureau( cancelToken?: CancelToken): Promise<IConfigurationBureau>;

    /**
     * Permet de récupérer la configuration de l'application Mobile
     * @return OK
     */
    getFeaturesConfigurationsMobile( cancelToken?: CancelToken): Promise<ConfigurationMobile>;

    /**
     * Permet de récupérer la configuration des modules
     * @return OK
     */
    getConfigurationModules( cancelToken?: CancelToken): Promise<IConfigurationModules>;
}

export class ConfigPublicClient extends AuthorizedApiBase implements IConfigPublicClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5002/";
    }

    /**
     * @return OK
     */
    getConfigurationFront(): Promise<IConfigurationFront> {
        let url_ = this.baseUrl + "/api/v2/configs/front";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetConfigurationFront(_response);
        });
    }

    protected processGetConfigurationFront(response: Response): Promise<IConfigurationFront> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IConfigurationFront;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IConfigurationFront>(null as any);
    }

    /**
     * @return OK
     */
    getConfigurationMobile(): Promise<IConfigurationMobile> {
        let url_ = this.baseUrl + "/api/v2/configs/mobile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetConfigurationMobile(_response);
        });
    }

    protected processGetConfigurationMobile(response: Response): Promise<IConfigurationMobile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IConfigurationMobile;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IConfigurationMobile>(null as any);
    }

    /**
     * @return OK
     */
    getConfigurationBureau(): Promise<IConfigurationBureau> {
        let url_ = this.baseUrl + "/api/v2/configs/bureau";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetConfigurationBureau(_response);
        });
    }

    protected processGetConfigurationBureau(response: Response): Promise<IConfigurationBureau> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IConfigurationBureau;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IConfigurationBureau>(null as any);
    }

    /**
     * Permet de récupérer la configuration de l'application Mobile
     * @return OK
     */
    getFeaturesConfigurationsMobile(): Promise<ConfigurationMobile> {
        let url_ = this.baseUrl + "/api/v2/configs/GetFeaturesConfigurationsMobile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFeaturesConfigurationsMobile(_response);
        });
    }

    protected processGetFeaturesConfigurationsMobile(response: Response): Promise<ConfigurationMobile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ConfigurationMobile;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConfigurationMobile>(null as any);
    }

    /**
     * Permet de récupérer la configuration des modules
     * @return OK
     */
    getConfigurationModules(): Promise<IConfigurationModules> {
        let url_ = this.baseUrl + "/api/v2/configs/modules";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetConfigurationModules(_response);
        });
    }

    protected processGetConfigurationModules(response: Response): Promise<IConfigurationModules> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IConfigurationModules;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IConfigurationModules>(null as any);
    }
}

export interface INonLusClient {

    /**
     * Appel la récupération du nombre de message non lus en fonction d'un idNationalPS
     * @param psOnly Si vrai, alors on ne compte que les messages du psConnecté sans ses délégants
     * @param boiteReception Si vrai, alors on ne compte pas les message archivé
     * @return OK
     */
    getCountMessageNonLus(idnationalps: string, psOnly: boolean, boiteReception: boolean,  cancelToken?: CancelToken): Promise<number>;
}

export class NonLusClient extends AuthorizedApiBase implements INonLusClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5002/";
    }

    /**
     * Appel la récupération du nombre de message non lus en fonction d'un idNationalPS
     * @param psOnly Si vrai, alors on ne compte que les messages du psConnecté sans ses délégants
     * @param boiteReception Si vrai, alors on ne compte pas les message archivé
     * @return OK
     */
    getCountMessageNonLus(idnationalps: string, psOnly: boolean, boiteReception: boolean): Promise<number> {
        let url_ = this.baseUrl + "/api/v2/modules/non-lus/count?";
        if (idnationalps === undefined || idnationalps === null)
            throw new globalThis.Error("The parameter 'idnationalps' must be defined and cannot be null.");
        else
            url_ += "idnationalps=" + encodeURIComponent("" + idnationalps) + "&";
        if (psOnly === undefined || psOnly === null)
            throw new globalThis.Error("The parameter 'psOnly' must be defined and cannot be null.");
        else
            url_ += "psOnly=" + encodeURIComponent("" + psOnly) + "&";
        if (boiteReception === undefined || boiteReception === null)
            throw new globalThis.Error("The parameter 'boiteReception' must be defined and cannot be null.");
        else
            url_ += "boiteReception=" + encodeURIComponent("" + boiteReception) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCountMessageNonLus(_response);
        });
    }

    protected processGetCountMessageNonLus(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export interface AbsencesConfig {
    available: boolean;
    endDateRequired: boolean;
    messageAbsenceRequired?: boolean | undefined;
    /** Affichage (ou non) de l'option "Désactiver les notifications" dans la pop-up d'absence */
    showDesactiverNotifs?: boolean | undefined;
}

export interface AuthConfig {
    /** Url de redirection pour le SSO avec le nom de domaine
domain/AutoConnectSSO/Redirect */
    autoConnectSsoRedirectBaseUrl: string;
    /** Type de mot de passe à utiliser */
    passwordType: PasswordType;
    /** Type de conversion certificat en refresh token */
    certificateConversionType: CertificateConversionType;
    /** Type d'identifiant du bureau */
    idPsType: IdPsType;
    /** Url de base de l'API protégée par certificat */
    certificateApiBase: string | undefined;
    /** Type du fournisseur d'identité */
    identityProviderType: IdentityProviderType;
    /** Si la définition de login/mdp depuis MSB est activée */
    accountCreationEnabled: boolean;
    /** Url de la page "mot de passe oublié" */
    forgotPasswordUrl?: string | undefined;
    /** Listes des domaines qui nécessitent l'utilisation d'un artefact ID (AURA) dans l'url */
    domainsWithAuthentication: string[];
}

/** Configuration liée à l'AutoConnectSSO */
export interface AutoConnectSSO {
    /** Url de base de l'AutoConnectSSO */
    baseUrl: string;
}

/** Configuration du module d'autosuggestion */
export interface AutoSuggestionModuleConfig {
    /** Indique si le module d'autosuggestion est activé */
    enabled: boolean;
    /** Regex de validation des adresses email MSS pour le Module d'autosuggestion */
    emailMSSValidationRegex?: string | undefined;
}

/** Configuration du bandeau d'infos */
export interface BandeauInfosConfig {
    /** Message d'infos */
    message: string;
    /** Bouton du bandeau d'infos */
    bouton?: BoutonBandeauInfos | undefined;
    /** Date de début d'affichage du bandeau */
    dateDebut: Date;
    /** Date de fin d'affichage du bandeau */
    dateFin?: Date | undefined;
    /** Couleur du message du bandeau */
    couleurTexte: string;
    /** Couleur de fond du bandeau */
    couleurFond: string;
}

export interface Boite {
    /** Libéllé de la boite */
    label: string;
    /** Si la boite est séparée en deux (envoyés et reçus) */
    distinctSentReceived: boolean;
    /** Types de conversations ratachés à la boite */
    types: ConversationType[];
    /** Libelle de la boîte-icône existant dans le front qu'on souhaite utilisée */
    iconLabel?: string | undefined;
    /** Identifiant du parent */
    idParent?: TypeMenuBoite | undefined;
    /** Défini si la boite doit afficher le nombre de message non lus ou pas */
    hideNbNonLus?: boolean | undefined;
}

export interface BoiteItems {
    inbox: Boite;
    all: Boite;
    drafts?: Boite | undefined;
    results?: Boite | undefined;
    events?: Boite | undefined;
    unreads: Boite;
    conversations: Boite;
    courrier?: Boite | undefined;
    mss?: Boite | undefined;
    mssPatient?: Boite | undefined;
    /** BoiteSollicitation pour les TLE et demande d'appui */
    teleExpertise?: BoiteSollicitation | undefined;
    /** BoiteSollicitation pour les TLE et demande d'appui */
    demandeAppui?: BoiteSollicitation | undefined;
    dgs?: Boite | undefined;
    aTraiter: Boite;
    favoris: Boite;
    /** MSSanté */
    msSante?: Boite | undefined;
}

/** BoiteSollicitation pour les TLE et demande d'appui */
export interface BoiteSollicitation extends Boite {
    /** Si la boite est séparée en fonction de l'état (en cours ou clôturé) */
    distinctByState: boolean;
}

export interface BoitesConfig {
    items: BoiteItems;
    /** Si on peut ajouter ou supprimer la présence du patient dans la file active du PS */
    manageFileActive: boolean;
    /** Si on doit afficher le choix des boites de réception des délégants */
    showDelegantChoices: boolean;
    /** Le nombre de conversations/mails à afficher par page */
    pageSize: number;
    /** Affiche le bouton d'export TLE dans la boite TLE */
    boutonExportTLE: boolean;
    /** Liste les sections qui permettent d'ordonnançer les boites de réception */
    ordonnancementSectionsBoites: SectionConfig[];
}

/** Configuration d'un bouton du bandeau d'infos */
export interface BoutonBandeauInfos {
    /** Libellé du bouton */
    libelle: string;
    /** Lien du bouton */
    lien: string;
}

export interface ButtonPlusConfig {
    sections: Section[];
}

/** Type de conversion certificat en refresh token */
export enum CertificateConversionType {
    Internal = "Internal",
    Artefact = "Artefact",
}

/** Configuration liée aux Conditions générales d'utilisation */
export interface CguConfig {
    /** Lien de redirection vers les Conditions générales d'utilisation */
    link: string;
}

/** Config du workflow de choix de type de conversation pour envoyer un fichier préalablement créé par l'imprimante */
export interface ChoixConversationConfig {
    /** Configuration des boutons de création de conversation */
    sections: Section[];
}

export enum Client {
    Aura = "aura",
    Paca = "paca",
    Occitanie = "occitanie",
    Pulsy = "pulsy",
    Idf = "idf",
    Hdf = "hdf",
}

export interface CommonConfig {
    /** Client (région) de l'application */
    client: Client;
    appName: string;
    /** Configuration liée à la visio */
    visio: VisioConfig;
    notification: NotificationConfig;
    /** Ouverture du dossier patient lors du clic sur son libéllé */
    openPatientFolder: boolean;
    /** Types de conversations gérés en tant que clavardage (Snacs.Messagerie) */
    conversationTypes: ConversationType[];
    /** Types de conversations gérés en tant que mail (Snacs.MSS / ApiSante) */
    mailTypes: ConversationType[];
    /** Configuration de la barre de SSO
Si null, on ne doit pas afficher la barre */
    autoConnectSsoBar?: AutoConnectSSO | undefined;
    /** Listes de fichiers JS à charger au lancement de l'application */
    javascriptFilesToLoad: string[];
    /** Status de connexion */
    statusConnexion: StatusConnexionConfig;
}

/** Configuration global lié à l'affihcga du mobile */
export interface CommonMobileConfig {
    /** Activation des fonctionnalités d'Odycare */
    odycareAvailable: boolean;
    tabs: TabConfig[];
    /** Permet la recherche de patient dans l'onglet Portail */
    searchPatientInPortailAvailable: boolean;
    /** Vérifie la validation des CGU au moment de la connexion */
    checkCGUValidation: boolean;
    /** Contenu du Menu mobile */
    globalMenu: GlobalMenuConfig;
    /** Récupère l'alert global pour l'afficher au démarrage de l'application */
    globalAlertAvailable: boolean;
    /** Indique si le clique sur le bouton de déconnexion inclue ou non la réinitialisation du compte */
    disconnectWithReinit: boolean;
}

export interface ConfigurationMobile {
    isVisio: boolean;
    isCourrier: boolean;
    isBrouillon: boolean;
    isMSS: boolean;
    isMSSMessages: boolean;
    isMSSPatient: boolean;
    isEchangePatient: boolean;
    isDGSUrgent: boolean;
    isDisplayPreferenceResultat: boolean;
    isDisplayPreferenceRDV: boolean;
    isTeleExpertise: boolean;
    isDemandeAppui: boolean;
    isFormulaireAvailable: boolean;
    isSollicitationEquipe: boolean;
    isSollicitationExpert: boolean;
    isCGUStepValidation: boolean;
    isGlobalAlertMessage: boolean;
    isWebSocketIO: boolean;
    isSousBoitesMSS: boolean;
    isSendMSSPatient: boolean;
    isMailUserToComplete: boolean;
    isStatut: boolean;
    isAppearWithAbsentStatut: boolean;
    isAppearAbsentWithDates: boolean;
    isAfficherTypePieceDansBoiteReception: boolean;
    isDocumentsJuridiques: boolean;
    isSearchPatientFromPortail: boolean;
    isMyProfileMenu: boolean;
    isDisplayProfessionPS: boolean;
    isEnableRemoveImportantQuestion: boolean;
    isTypeMimeVignetteCondition: boolean;
    isRepondreA: boolean;
    isSupprimerEchange: boolean;
    pageSizeEchange: number;
    isAccessPatientFolder: boolean;
    isFileActiveDistancePatientTab: boolean;
    isFileActiveDernierDossiersConsultesTab: boolean;
    isCreationPatientScreen: boolean;
    isShareDocumentToPatientFolder: boolean;
    isShareDocumentToPatientFolderForCourrierOnly: boolean;
    isShareDocumentDefaultValueNouvelleConversation: boolean;
    isTagStatutPatient: boolean;
    isFolderForConvPatientCentered: boolean;
    isChangePatientHabilitationAvailable: boolean;
    isInvitationInactiveColleagueEnable: boolean;
    isInvitationColleagueAbsentAnnuaireEnable: boolean;
    isInvitationFromBackend: boolean;
    isInvitationSMS: boolean;
    isAutocompleteRecherchePS: boolean;
    isSearchWithoutSelectionAvailable: boolean;
    isSortedByLastName: boolean;
    isShowAnnuairePPDetail: boolean;
    isLongLabelsDestinataires: boolean;
    isProfessionFieldAvailable: boolean;
    isFiltrePS: boolean;
    typesConversationsGestionMSS: ConversationType[];
    typesConversationsGestionChat: ConversationType[];
    isShowGroupSection: boolean;
    /** Timer qui indique le temps jusqu'auquel on peut supprimer le message en partant de l'heure d'envoi de celui-ci (en minutes) */
    timerSupprimerEchange: number;
    isMuteAvailable: boolean;
    isMentionAvailable: boolean;
    showChatSollicitationDesactiveText: boolean;
    moduleRechercheExpertRessource: boolean;
}

export enum ContextFilter {
    ClavardageOnly = "ClavardageOnly",
    NotExpertsOnly = "NotExpertsOnly",
}

export enum ConversationType {
    BoiteReception = "BoiteReception",
    Brouillon = "Brouillon",
    NonLus = "nonLus",
    Tous = "tous",
    Conversation = "Conversation",
    Courrier = "Courrier",
    Resultat = "Resultat",
    RendezVous = "RendezVous",
    Favoris = "favoris",
    ATraiter = "aTraiter",
    MSS = "MSS",
    EchangePatient = "EchangePatient",
    DGS = "DGS",
    MSSPatient = "MSSPatient",
    CourrierPatient = "CourrierPatient",
    AucunType = "AucunType",
    TeleExpertise = "TeleExpertise",
    DemandeAppui = "DemandeAppui",
}

export interface ConversationsConfig {
    /** Configuration liée aux échanges */
    echanges: EchangesConfig;
    /** Configuration liée à la création d'un message */
    newMessage: NewMessageConfig;
    /** Configuration liée au formulaires (Odycare et Dominho) */
    form: FormConfig;
    /** Si on peut supprimer le status "Important" et "Question" d'une conversation */
    removeImportantQuestion: boolean;
    /** Si on doit afficher les conversations existantes lors de la création d'une conversation */
    showExistingConversations: boolean;
    isMuteAvailable: boolean;
    /** Ajoute le bouton "Créer un groupe à partir de cette conversation" dans le menu d'une conversation */
    createGroupFromConversation: boolean;
    /** Message de supression d'un message */
    deletedMessageLabel: string;
    /** Lien vers la création de groupe */
    creationGroupe: string;
    /** Config lié aux sollicitations */
    sollicitation: SollicitationConfig;
    /** Contient le message affiché si un utilisateur est inactif dans une conversation */
    labelUtilisateurConversationInactif?: string | undefined;
    /** Active les réactions à un échange avec les emojis */
    enableReactionsEmojis: boolean;
    /** Nombre de message a charger par l'infinite loader (0 = charger tous les messages) */
    infiniteScrollLoadNumber: number;
}

export enum CreateTypeEnum {
    Conversation = "Conversation",
    TeleExpertise = "TeleExpertise",
    DemandeAppui = "DemandeAppui",
    Mss = "Mss",
    MssPatient = "MssPatient",
    Courrier = "Courrier",
}

/** Configuration liée à la suppression d'un échange Si = null alors la suppression est désactivée */
export interface DeleteConfig {
    timer?: number | undefined;
}

export interface DisplayInMrps {
    /** Obsolete ? conversation existante qui après webif a été déplacé */
    conversations: boolean;
    /** Affichage de l'onglet des acteurs */
    acteursDossier: boolean;
    /** Affichage des experts et des équipe ressources */
    expertRessource: boolean;
    /** Pop-up de saisie de mail MSS dans le cas ou le PS n'en a pas */
    saisieEmail: boolean;
    /** Permet de sélectionner tous les ps (Obsolete ?) */
    selectAll: boolean;
    /** Affiche le bouton de géolocalisation */
    geolocalisation: boolean;
}

export interface DocumentsConfig {
    shareToPatientFolder: ShareToPatientFolderConfig;
    onDocumentClick: OnDocumentClick;
    visioneuse: VisioneuseConfig;
    vignette: VignetteConfig;
    mimetypesAutorises: string[];
    /** Types de documents ouvrables sur la visionneuse interne MS */
    mimetypesToOpen: string[];
    erreurFormatDocument: string;
    documentTailleMaxEnMo: number;
    erreurTailleDocument: string;
    /** Les types pieces par defaut */
    typePiecesDefault: TypePiecesDefaultConfig;
    /** Type d'une PJ Synthese */
    typePieceSynthese: number[];
    /** Permettre l'ouverture du diapo photo */
    openDiapoPhoto: boolean;
}

/** Configuration liée aux échanges */
export interface EchangesConfig {
    /** Configuration liée à la suppression d'un échange
Si = null alors la suppression est désactivée */
    delete?: DeleteConfig | undefined;
    /** Si on peut répondre à un échange */
    answer: boolean;
}

/** Configuration d'affichage dans l'écran de file active (recherche patient) */
export interface FileActiveConfig {
    /** Affichage de l'onglet distance */
    displayDistance: boolean;
    /** Affichage du statut RNIV du patient */
    displayStatutRNIV: boolean;
    /** Permet la rediraction vers l'éran de création d'un patient (lié à Odycare) */
    creationPatientAvailable: boolean;
}

/** Configuration liée au formulaires (Odycare et Dominho) */
export interface FormConfig {
    showButtonAccessOdycareForm: boolean;
    /** Défini si le mode chat actif des sollicitations est activé */
    enableChatDesactivation: boolean;
    /** Url formulaire patient */
    urlFormulaireAvecPatient?: string | undefined;
    /** Url formulaire sans patient */
    urlFormulaireSansPatient?: string | undefined;
    /** Defini le type de formulaire utilisé par l'environement */
    typeFormulaire: TypeFormulaire;
    /** Défini si la facturation est activé */
    isFacturationEnabled: boolean;
    /** Include the PDF report of a form in the conversation */
    includeRapportTeleExpertise: boolean;
}

/** Contenu du Menu mobile */
export interface GlobalMenuConfig {
    /** Affiche le bouton pour accéder aux documents juridiques CGU, RGPD, Mentions Légales */
    displayDocumentsJuridiques: boolean;
    /** Affiche le bouton pour rediriger vers le profil du ps connecté dans le portail de config */
    displayMyProfil: boolean;
    /** Affiche le bouton pour rediriger vers le store afin de noter l'application */
    displayRate: boolean;
}

/** Configuration spécifique au mobile */
export interface IConfigurationBureau {
    /** Configuration liée à l'authentification */
    auth: AuthConfig;
    /** Configuration liée à la LGC */
    lgc: LGCConfig;
    /** Links accessibles dans le menu roue crantée */
    links: Link[];
    /** Configuration de mise à jour automatique */
    update: UpdateConfig;
    /** Configuration liée à l'imprimante virtuelle (menu choix de conversation) */
    printer: PrinterConfig;
    /** Configuration liée aux Conditions générales d'utilisation */
    cgu?: CguConfig | undefined;
}

/** Configuration commune à tous les front (web, mobile, bureau) */
export interface IConfigurationFront {
    /** Configuration commune */
    common: CommonConfig;
    /** Configuration liée aux mails */
    mails: MailsConfig;
    /** Configuration liée aux patients */
    patient: PatientConfig;
    /** Configuration liée au module de recherche PS */
    moduleRecherchePS: ModuleRecherchePSConfig;
    /** Configuration liée au thème */
    theme: ThemeConfig;
    /** Configuration liée aux conversations */
    conversations: ConversationsConfig;
    /** Configuration liée aux boites */
    boites: BoitesConfig;
    /** Configurations liée aux documents */
    documents: DocumentsConfig;
    /** Configurations liée aux workflows */
    workflows: WorkflowsConfig;
    /** Configurations liée aux absences */
    absences: AbsencesConfig;
    /** Configurations liée au websocket */
    websocket: WebsocketConfig;
    /** Configuration liée au bandeau d'infos */
    bandeauInfos: BandeauInfosConfig;
}

/** Configuration spécifique au mobile */
export interface IConfigurationMobile {
    /** Configuration global lié à l'affihcga du mobile */
    common: CommonMobileConfig;
    /** Configuration d'affichage dans l'écran de file active (recherche patient) */
    fileActivePatient: FileActiveConfig;
    /** Configuration d'affichage dans le module de recherche du mobile */
    moduleRecherchePs: ModuleRechercheMobileConfig;
}

/** Configuration commune à tous les modules */
export interface IConfigurationModules {
    /** Configuration module message non lus */
    nonLus: NonLusModule;
}

/** Type d'identifiant du bureau */
export enum IdPsType {
    IdTechPs = "IdTechPs",
    IdNational = "IdNational",
}

export enum IdentityProviderType {
    Keycloak = "Keycloak",
    IdentityServer = "IdentityServer",
}

/** Parmère liés à la fonctionnalité d'invitation d'un confrere */
export interface InvitationConfrereConfig {
    /** Activation de la fonctionnalité */
    invitationAvailable: boolean;
    /** Affichage du champ "Tèl. Mobile" dans l'écran d'invitation d'un confrere */
    viaSms: boolean;
    /** Un seul input pour le téléphone ou l'adresse */
    mergeEmailAndPhone: boolean;
}

export interface Item {
    label: string;
    tooltip: string;
    createType: CreateTypeEnum;
}

/** Configuration de la synchro LGC (Logiciel de Gestion de Cabinet) - Ce qui permet de synchroniser automatiquement des documents sur la machine depuis MSB */
export interface LGCConfig {
    /** Si on doit ouvrir ou non la page de configuration lors de la première connexion */
    openConfigurationOnFirstConnection: boolean;
    /** Liste des types de documents que l'on souhaite synchroniser */
    typesDocs: TypesDoc[];
    /** Tags de nommage des documents que l'on souhaite synchroniser */
    tags: string[];
}

/** Configuration liée au Link */
export interface Link {
    /** Label du Link */
    label: string;
    /** Url du Link */
    url: string;
    /** Authentification required */
    requiresAuth: boolean;
}

/** Configuration liée aux mails */
export interface MailsConfig {
    /** Pop up Create MSS Account */
    popUpCreateMSSAccount: PopUpCreateMSSAccountConfig;
    /** Mimetype autorisé pour les courriers. Si vide, alors tous les mimetypes sont autorisés. */
    allowedMimeTypeCourrier?: string[] | undefined;
}

export interface ModuleRechercheConfig {
    /** Indique si il est possible de sélectionner plusieurs PS */
    multiSelection: boolean;
    /** Indique ce qui doit etre aficher dans le MRPS */
    show: DisplayInMrps;
    /** Forcer le filtre qui est dans le MRPS (en haut à gauche) */
    defaultFilter: string;
    /** Utiliser côté MRPS pour connaitre le contexte, a changer pour prendre le niveau au dessus */
    nouveauCourrier: boolean;
    /** Force la recherche dans l'annuaire mss (duplicat modemss) */
    annuaireMss: boolean;
    /** Force la recherche dans l'annuaire sécu, utilisateur de nos appli */
    annuaireSecuOnly: boolean;
    /** Force la recherche dans l'annuaire mss */
    modeMss: boolean;
    /** Regroupe les filtres contextuels pour le MRPS */
    contextFilters: ContextFilter[];
    /** Context pour l'autosuggestion */
    utilisationContext: string;
    /** Forcer l'affichage du bouton + de sélection du ps */
    mustShowSelectButton: boolean;
}

/** Configuration d'affichage dans le module de recherche du mobile */
export interface ModuleRechercheMobileConfig {
    /** Parmère liés à la fonctionnalité d'invitation d'un confrere */
    invitationConfrere: InvitationConfrereConfig;
    /** Affiche la pop-up de détail du ps */
    displayPopupDetailPs: boolean;
    /** Affiche la section groupe dans le module de recherche */
    displayGroupe: boolean;
    /** Affiche une seule section dans le cas 'une téléexpertise ou d'une demande d'appui */
    displayOneSectionSollicitation: boolean;
}

export interface ModuleRecherchePSConfig {
    available: boolean;
    useAnnuaireMSSOnly: boolean;
    filtrerPPOnly: boolean;
    geolocation: boolean;
    ignoreEmail: boolean;
    autocompleteWho: boolean;
    isProfessionFieldAvailable: boolean;
    isSearchWithoutSelectionAvailable: boolean;
    showProfessionInSelectedPsList: boolean;
    showInvitationConfrere: boolean;
    showLessResult: boolean;
    hideFavorisMSS: boolean;
    hideRecentsMSS: boolean;
    labels: ModuleRecherchePSLabels;
    /** Configuration du module d'autosuggestion */
    autoSuggestionModule?: AutoSuggestionModuleConfig | undefined;
}

export interface ModuleRecherchePSLabels {
    labelSearchPlaceholderProfession: string;
    searchPlaceholderLocation: string;
    messagePopupInactif: string;
}

export interface ModuleRecherchePatientConfig {
    displayRecentPatients: boolean;
    showSearchInAnnuaireButton: boolean;
}

/** Configuration liée à la création d'un message */
export interface NewMessageConfig {
    /** Si les options d'importances sont disponibles lors de la création d'un message */
    isImportancesAvailable: boolean;
    isMentionsAvailable: boolean;
}

/** Section des configuration du module NonLus */
export interface NonLusModule {
    /** Permet de paramétrer le target de lien présent dans le widget nonLus */
    target: string;
    /** Permet de paramétrer le title de lien présent dans le widget nonLus */
    title: string;
    /** Permet de paramétrer l'icone présent dans le widget nonLus */
    icon: string;
    /** Permet de rediriger sur le lien de la messagerie */
    link: string;
}

export interface NotificationConfig {
    /** Titre de la fenetre de notification */
    intituleNotificationWindow: string;
}

export enum OnDocumentClick {
    Download = "Download",
    View = "View",
}

/** Type de mot de passe à utiliser */
export enum PasswordType {
    Password = "Password",
    Pin = "Pin",
}

export interface PatientConfig {
    /** Configuration du module de recherche patient */
    moduleRecherchePatient: ModuleRecherchePatientConfig;
    /** Url de création d'un dossier patient */
    urlCreateDossierPatient: string;
    /** Url d'acces a un dossier patient */
    urlOpenDossierPatient: string;
    urlCreatePatientMscAccount?: string | undefined;
    /** Nom de l'appli de gestion des patients */
    patientAppName: string;
    /** Gestion de l'affichage des infos détaillées du patient */
    displayExtendedInfosPatient: boolean;
}

/** Configuration liée à la popup Medimail */
export interface PopUpCreateMSSAccountConfig {
    /** Texte d'indication à l'utilisateur */
    text: string;
    /** Link pour créer le compte ou service assistance */
    link: string;
}

/** Configuration liée à l'imprimante virtuelle */
export interface PrinterConfig {
    /** Configuration du menu de choix de conversation après avoir imprimé un fichier */
    choixConversation: ChoixConversationConfig;
}

export interface Section {
    description: string;
    type: TypeEnum;
    items: Item[];
}

/** Configuration d'une section d'ordonnancement des boites de réception */
export interface SectionConfig {
    /** Identifiants des boites de réception concernées par la section
Les boites sont ordonnées dans l'ordre d'affichage */
    boites: string[];
}

export interface ShareToPatientFolderConfig {
    /** Si le bouton au clic droit sur un document est disponible */
    showButton: boolean;
    /** Si la checkbox Partager sur ... dans l'écran de création de courrier est coché par défaut */
    defaultChecked: boolean;
}

/** Configuration liée aux sollicitations */
export interface SollicitationConfig {
    /** L'url a contenant les infos sur la facturation */
    infosFacturation?: string | undefined;
    /** Le sujet de la sollicitation */
    sujetDemandeAppui: string;
    /** Couleur icône Sollicitation */
    distinctStateByColor: boolean;
    /** Nombre de caractères maximum de l'url outil */
    limiteOutilTelemedecineURL?: number | undefined;
}

export interface StatusConnexion {
    status: StatusConnexionEnum;
    libelle: string;
}

export interface StatusConnexionConfig {
    status: StatusConnexion[];
}

export enum StatusConnexionEnum {
    STATUT_USER_INACTIF = "STATUT_USER_INACTIF",
    STATUT_ABSENT = "STATUT_ABSENT",
    STATUT_EN_LIGNE = "STATUT_EN_LIGNE",
    STATUT_USER_ACTIF_MonSisra = "STATUT_USER_ACTIF_MonSisra",
    STATUT_USER_ACTIF_MSSante = "STATUT_USER_ACTIF_MSSante",
    STATUT_IGNORE = "STATUT_IGNORE",
}

/** Propriétés d'une tab affiché en bas de l'application mobile */
export interface TabConfig {
    /** Nom affiché sur la tab */
    name: string;
    /** Chemin de redirection de la tab au clique dessus */
    route: string;
}

/** Options spécifiques aux téléexpertises */
export interface TeleExpertiseOptions {
    /** Regex pour vérifier le numéro de facturation renseigné par l'utilisateur lors : 
- la création / finalisation d'une téléexpertise 
- la modification de ses préférences de sollicitation */
    numFacturationRegex?: string | undefined;
    /** Regex pour vérifier le NIR du patient */
    nirRegex?: string | undefined;
}

export interface ThemeConfig {
    backgroundColor: string;
    /** Couleur spécifique pour les boutons */
    mssTextColor: string | undefined;
}

/** Type passé de msb (depuis  la 1.12) à MonSisra.API (puis vers Snacs.SynchroDoc) */
export enum TypeConvSynchroDoc {
    Aucune = "Aucune",
    Conversation = "Conversation",
    Resultat = "Resultat",
    RendezVous = "RendezVous",
    Courrier = "Courrier",
    MSS = "MSS",
    DGS = "DGS",
    EchangePatient = "EchangePatient",
    MSSPatient = "MSSPatient",
    CourrierPatient = "CourrierPatient",
    TeleExpertise = "TeleExpertise",
    DemandeAppui = "DemandeAppui",
}

export enum TypeEnum {
    Mss = "Mss",
    MssPatient = "MssPatient",
    Messagerie = "Messagerie",
}

/** Contient les differents type de formulaires gérés par l'API */
export enum TypeFormulaire {
    Dominho = "Dominho",
    Odycare = "Odycare",
}

export enum TypeMenuBoite {
    BoiteReception = "BoiteReception",
    Conversation = "Conversation",
    Courrier = "Courrier",
    CourrierPatient = "CourrierPatient",
    DGS = "DGS",
    DemandeAppui = "DemandeAppui",
    EchangePatient = "EchangePatient",
    Evenement = "Evenement",
    MSS = "MSS",
    MSSPatient = "MSSPatient",
    NombreNonLu = "NombreNonLu",
    RendezVous = "RendezVous",
    Resultat = "Resultat",
    TeleExpertise = "TeleExpertise",
    ATraiter = "ATraiter",
    Favoris = "Favoris",
    NonLus = "NonLus",
    Tous = "Tous",
    MSSante = "MSSante",
}

/** Les types pieces par defaut */
export interface TypePiecesDefaultConfig {
    /** IdTypiece pour les PJ de conversation */
    idTypePieceAutreDocument: number;
    /** IdTypePiece pour les images de conversation */
    idTypePieceImage: number;
    /** Ancien IdTypePiece pour les AutreDocuments */
    idTypePieceOldAutreDocument: number;
    /** Ancien IdTypePiece pour les Images */
    idTypePieceOldImage: number;
}

/** Informations des types de documents à télécharger pour la synchro LGC */
export interface TypesDoc {
    /** Libellé du type */
    libelleType: string;
    /** Libellé d'aide du type (infos supplémentaires) */
    libelleAideType: string;
    /** Types de conv */
    types: TypeConvSynchroDoc[];
}

/** Configuration de mise à jour automatique */
export interface UpdateConfig {
    /** Mapping des versions de l'application (version interne => version publique) */
    mapping: { [key: string]: string; };
    webEtagUrls: string[];
}

export interface VignetteConfig {
    available: boolean;
    /** Si l'affichage des vignettes se base sur le type MIME et non pas le type de document (Image/Autre)
TODO à voir si c'est a maintenir vu que AURA l'utilise aussi */
    basedOnMimeType: boolean;
}

/** Configuration liée à la visio */
export interface VisioConfig {
    /** Si la fonctionnalité de visio est disponible */
    available: boolean;
    /** Délai en millisecondes avant de refaire sonner une même visio */
    sonnerieTimeout: number;
    /** Url pour rejoindre la visio */
    visioUrl: string;
    /** Type de visio utilisée
Exemple : pandalab ou jitsi */
    type: VisioType;
}

/** Enumeration representing different types of Visio platforms. */
export enum VisioType {
    Jitsi = "jitsi",
    Pandalab = "pandalab",
}

export interface VisioneuseConfig {
    setPsIdentifieInLienDoc: boolean;
}

/** Configuration du websocket */
export interface WebsocketConfig {
    /** Timeout de vérification du websocket en ms */
    pingIsAliveDelay: number;
}

/** Represente la configuration pour le workflow de partage de conversation */
export interface WorkflowConversationShareOptions {
    /** Si la checkbox Partager ces informations dans le dossier du patient est disponible */
    isPartageDossierPatient: boolean;
}

/** Représente la configuration pour le workflow de partage de courrier sur la checkbox "Envoyer une copie dans mon logiciel métier". */
export interface WorkflowCourrierShareLogicielMetier {
    /** Si la checkbox dans l'écran de création de conversation / courrier est disponible */
    showCheckbox: boolean;
    /** États par défaut de la checkbox dans l'écran de création de conversation / courrier */
    defaultStates: DefaultStates;
}

/** Represente la configuration pour le workflow de partage de courrier sur la checkbox "Partager sur Ma Sante Connectee". */
export interface WorkflowCourrierShareOptions {
    /** Si la checkbox Partager sur Ma Santé Connectée dans l'écran de création de courrier est disponible */
    isMaSanteConnectee: boolean;
    /** Si la checkbox Envoyer une copie dans mon logiciel métier dans l'écran de création de courrier est disponible + Etat de la checkbox */
    logicielMetier?: WorkflowCourrierShareLogicielMetier | undefined;
}

/** Liste des types de workflow */
export enum WorkflowType {
    CreateCourrierPs = "CreateCourrierPs",
    CreateCourrierPatient = "CreateCourrierPatient",
    CreateMss = "CreateMss",
    CreateConversation = "CreateConversation",
    CreateDemandeAppui = "CreateDemandeAppui",
    CreateTeleExpertise = "CreateTeleExpertise",
    EditConversation = "EditConversation",
    EditDemandeAppui = "EditDemandeAppui",
    EditTeleExpertise = "EditTeleExpertise",
}

export interface WorkflowsConfig {
    /** Si true, les courriers sont rangés dans la section MSS */
    manageCourrierAsMss: boolean;
    /** Configuration du bouton plus */
    buttonPlus: ButtonPlusConfig;
    /** Options de partage du courrier */
    courrierShareOptions: WorkflowCourrierShareOptions;
    /** Options de partage de conversation */
    conversationShareOptions: WorkflowConversationShareOptions;
    /** Défini le workflow a lancer lorsque l'utilisateur repond a un courrier */
    repondreCourrierAs: WorkflowType;
    /** Défini les config du module de recherche en fonction du workflow en cours */
    moduleRecherchePs: ModuleRecherchePs;
    /** Options spécifiques aux téléexpertises */
    teleExpertises: TeleExpertiseOptions;
}

export interface DefaultStates {
    BoiteReception: boolean;
    Brouillon: boolean;
    nonLus: boolean;
    tous: boolean;
    Conversation: boolean;
    Courrier: boolean;
    Resultat: boolean;
    RendezVous: boolean;
    favoris: boolean;
    aTraiter: boolean;
    MSS: boolean;
    EchangePatient: boolean;
    DGS: boolean;
    MSSPatient: boolean;
    CourrierPatient: boolean;
    AucunType: boolean;
    TeleExpertise: boolean;
    DemandeAppui: boolean;
}

export interface ModuleRecherchePs {
    CreateCourrierPs: ModuleRechercheConfig;
    CreateCourrierPatient: ModuleRechercheConfig;
    CreateMss: ModuleRechercheConfig;
    CreateConversation: ModuleRechercheConfig;
    CreateDemandeAppui: ModuleRechercheConfig;
    CreateTeleExpertise: ModuleRechercheConfig;
    EditConversation: ModuleRechercheConfig;
    EditDemandeAppui: ModuleRechercheConfig;
    EditTeleExpertise: ModuleRechercheConfig;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}